export async function putRequestWrapper<Body, Response>({
  url,
  body,
}: {
  url: string;
  body?: Body;
}): Promise<Response> {
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  });

  if (!response.ok) {
    // const error: unknown = await response.json();

    // TODO - Add functionality to detect error type and print error.

    throw new Error(`Error encountered when making PUT request to "${url}"`);
  }

  return response.json() as Response;
}
